import { getPreviewDate } from '../preview/PreviewProvider';
import { addQueryParam } from '../utils/url';

export const appendPreviewDate = (url: string) => {
  const previewDate = getPreviewDate();
  return previewDate ? addQueryParam('date', previewDate, url) : url;
};
